export default class Team {
    static fromData(data) {
        const team = new Team();
        team.id = data.id;
        team.name = data.name;

        return team;
    }
}
